import { render, staticRenderFns } from "./mNav.vue?vue&type=template&id=1670d834&scoped=true"
import script from "./mNav.vue?vue&type=script&lang=js"
export * from "./mNav.vue?vue&type=script&lang=js"
import style0 from "./mNav.vue?vue&type=style&index=0&id=1670d834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1670d834",
  null
  
)

export default component.exports